var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t("influencer_panel.generate_link_title"),
        "ok-title": _vm.$t("influencer_panel.generate_link"),
        "cancel-title": _vm.$t("action.cancel"),
        "cancel-variant": "outline-secondary",
        "ok-disabled":
          !_vm.selectedParticipation ||
          _vm.saving ||
          _vm.selectedProduct === "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
        hidden: _vm.reset,
      },
    },
    [
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("influencer_panel.link_campaign") } },
        [
          _c("b-form-select", {
            attrs: { options: _vm.participationOptions },
            model: {
              value: _vm.selectedParticipation,
              callback: function ($$v) {
                _vm.selectedParticipation = $$v
              },
              expression: "selectedParticipation",
            },
          }),
        ],
        1
      ),
      _vm.productOptions.length > 1
        ? _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("influencer_panel.link_scope"),
                description:
                  _vm.selectedProduct === null
                    ? _vm.$t("influencer_panel.whole_campaign_hint")
                    : "",
              },
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.productOptions },
                model: {
                  value: _vm.selectedProduct,
                  callback: function ($$v) {
                    _vm.selectedProduct = $$v
                  },
                  expression: "selectedProduct",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-form-group",
        {
          attrs: {
            label: _vm.$t("influencer_panel.link_channel"),
            description: _vm.$t("influencer_panel.link_channel_hint"),
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.channelOptions },
            model: {
              value: _vm.selectedChannel,
              callback: function ($$v) {
                _vm.selectedChannel = $$v
              },
              expression: "selectedChannel",
            },
          }),
        ],
        1
      ),
      _vm.activeCoupon
        ? _c("div", { staticClass: "generate-link__coupon" }, [
            _c(
              "div",
              { staticClass: "generate-link__coupon-row" },
              [
                _c("feather-icon", { attrs: { icon: "TagIcon", size: "14" } }),
                _c("code", { staticClass: "generate-link__coupon-code" }, [
                  _vm._v(_vm._s(_vm.activeCoupon.code)),
                ]),
                _vm.couponDiscount
                  ? _c("b-badge", { attrs: { variant: "light-primary" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("influencer_panel.coupon_discount", {
                              discount: _vm.couponDiscount,
                            })
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _c("hb-copy-button", {
                  staticClass: "ml-auto",
                  attrs: { text: _vm.activeCoupon.code, "allow-share": false },
                }),
              ],
              1
            ),
            _c("p", { staticClass: "generate-link__coupon-note" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.activeCoupon.active
                      ? _vm.$t("influencer_panel.coupon_auto_applied")
                      : _vm.$t("influencer_panel.coupon_inactive")
                  ) +
                  " "
              ),
            ]),
          ])
        : _vm._e(),
      _vm.createdLink
        ? _c("div", { staticClass: "generate-link__result" }, [
            _c("div", { staticClass: "generate-link__result-label" }, [
              _vm._v(_vm._s(_vm.$t("influencer_panel.link_created"))),
            ]),
            _c(
              "div",
              { staticClass: "generate-link__result-row" },
              [
                _c("code", { staticClass: "generate-link__url" }, [
                  _vm._v(_vm._s(_vm.createdLink.short_url)),
                ]),
                _c("hb-copy-button", {
                  attrs: { text: _vm.createdLink.short_url },
                }),
              ],
              1
            ),
            _vm.activeCoupon && _vm.activeCoupon.active
              ? _c("div", { staticClass: "generate-link__result-coupon" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("influencer_panel.link_coupon_note", {
                          code: _vm.activeCoupon.code,
                        })
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }